import { useTranslation } from "react-i18next";
import PublicLayout from "@/components/public/PublicLayout";
import Seo from "@/components/public/Seo";
import { PageHero, CategoryGrid, CtaBand } from "@/components/public/blocks";

export default function Categories() {
  const { t } = useTranslation();
  return (
    <PublicLayout testId="categories-page">
      <Seo path="/categories" title={t("site.seo.catsTitle")} description={t("site.seo.catsDesc")} />
      <PageHero badge={t("site.nav.categories")} title={t("site.cats.title")} subtitle={t("site.cats.subtitle")} />
      <section className="max-w-7xl mx-auto px-5 pb-20">
        <CategoryGrid detailed />
      </section>
      <CtaBand title={t("site.cats.ctaTitle")} body={t("site.cats.ctaBody")} to="/register" cta={t("landing.startShopping")} testId="categories-shop-cta" />
    </PublicLayout>
  );
}
